import { render, staticRenderFns } from "./data-grid.vue?vue&type=template&id=80ab9f50"
import script from "./data-grid.vue?vue&type=script&lang=js"
export * from "./data-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports